import {Button, Grid, Modal} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import {PaymentCard as PaymentCardItem} from './PaymentCard'
import {PaymentCardAdd} from './PaymentCardAdd'
import {usePaymentCardList} from './PaymentCardList.hooks'
import type {Props} from './PaymentCardList.types'

export const PaymentCardList = memo(function PaymentCardList(props: Props): React.ReactElement<Props> {
  const {fetchBindingUrl, onAdd} = props
  const {variant, addDisabled, isPending, cards, currentCard, changeHandler, clickHandler, translates} =
    usePaymentCardList(props)

  return (
    <>
      <Modal.Header text={translates.subtitle} title={translates.title} />
      <Modal.Body p="m">
        <Grid size="m" container>
          {cards.map(c => (
            <Grid key={c.id} xs={6} item>
              <PaymentCardItem card={c} checked={c.id === currentCard?.id} onPress={changeHandler} />
            </Grid>
          ))}
          <Grid xs={6} item>
            <PaymentCardAdd disabled={addDisabled} fetchBindingUrl={fetchBindingUrl} onAdd={onAdd} />
          </Grid>
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <Button disabled={!currentCard} loading={isPending} onPress={clickHandler(currentCard)} variant={variant}>
            {translates.button}
          </Button>
        </Modal.Footer.Controls>
      </Modal.Footer>
    </>
  )
})
